var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 38,
    viewBox: "0 0 20 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3067_196557",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(0.83205 0.5547 0 1 0.03125 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3067_196557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.26536 11.8509L7.01882 10.3532C6.80665 10.2117 6.6288 10.0067 6.48527 9.73797C6.34174 9.46945 6.26997 9.20844 6.26997 8.95494C6.26997 8.70144 6.34167 8.53674 6.48506 8.46083C6.62845 8.38492 6.80616 8.41765 7.0182 8.559L13.0036 12.5492C13.2156 12.6906 13.3944 12.8956 13.54 13.1641C13.6856 13.4327 13.7584 13.6937 13.7584 13.9472C13.7584 14.2007 13.6867 14.3661 13.5431 14.4432C13.3996 14.5205 13.2218 14.4885 13.0096 14.347L10.763 12.8493V14.6536C10.763 14.9091 10.6913 15.0755 10.5478 15.1528C10.4042 15.2299 10.2264 15.1978 10.0142 15.0563C9.80203 14.9149 9.62418 14.7099 9.48065 14.4414C9.33712 14.1727 9.26536 13.9106 9.26536 13.6551V11.8509ZM4.02344 22.1878V16.7448C4.02344 16.4899 4.09479 16.3226 4.23748 16.2427C4.38018 16.1628 4.55699 16.1932 4.76791 16.3338C4.97884 16.4744 5.1562 16.6792 5.30001 16.948C5.44396 17.217 5.51593 17.4793 5.51593 17.735V17.7575L7.76766 19.2587V16.5587L7.74894 16.5462C7.53622 16.4044 7.35788 16.1992 7.21394 15.9307C7.06999 15.6623 6.99802 15.4006 6.99802 15.1456C6.99802 14.8906 7.06978 14.7246 7.21331 14.6478C7.3567 14.5709 7.53448 14.6032 7.74666 14.7446L12.2755 17.7639C12.4875 17.9052 12.6664 18.1102 12.812 18.3788C12.9576 18.6473 13.0304 18.9084 13.0304 19.1619C13.0304 19.4154 12.9584 19.5806 12.8145 19.6574C12.6705 19.7345 12.4922 19.7021 12.2795 19.5603L12.2607 19.5478V22.254L14.5073 23.7517V23.7292C14.5073 23.4736 14.579 23.3071 14.7226 23.2298C14.8661 23.1524 15.0439 23.1845 15.2561 23.326C15.4683 23.4674 15.6461 23.6722 15.7897 23.9404C15.9332 24.2084 16.005 24.4699 16.005 24.7249V30.1679C16.005 30.4228 15.9336 30.5901 15.7909 30.67C15.6482 30.7499 15.4714 30.7195 15.2605 30.5789C15.0496 30.4383 14.8723 30.2338 14.7286 29.9655C14.5851 29.6973 14.5133 29.4357 14.5133 29.1807V29.1557L5.52113 23.161V23.186C5.52113 23.441 5.44978 23.6071 5.30708 23.6845C5.16439 23.7619 4.98758 23.7303 4.77665 23.5896C4.56573 23.449 4.38746 23.2439 4.24185 22.9744C4.09624 22.705 4.02344 22.4428 4.02344 22.1878ZM5.52113 21.361L14.5073 27.3517V25.5517L10.763 23.0556V18.5556L9.26536 17.5571V22.0571L5.52113 19.561V21.361Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.544fc814b3b703e182f6053ca027c309.svg";
export { ForwardRef as ReactComponent };